import ReactDOM from "react-dom"

import "./index.css"
import "typeface-roboto"
import { getAppWithProviders } from "./components/App/utils"

ReactDOM.render(getAppWithProviders(), document.getElementById("root"))
